import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from './BlogPosts';

const BlogListPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Our Blog</h1>
        <p className="text-gray-600 mb-10">Tips, news, and updates from the team at Pure Clean Shopping.</p>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {blogPosts.map(post => (
            <div key={post.id} className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
              <img src={post.img} />
              <h2 className="text-xl font-semibold text-gray-800 mb-2">
                <Link to={`/blog/${post.title}`} className="hover:text-[#fe7590]">{post.title}</Link>
              </h2>
              <p className="text-gray-600 mb-4">{post.excerpt}</p>
              <Link to={`/blog/${post.title}`} className="text-[#fe7590] font-medium hover:underline">
                Read More →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogListPage;
